import React, { useState } from 'react'
import { connect } from 'react-redux'
import EditUserEmailForm from '../../../components/forms/account/EditUserEmailForm'
import { updateUserEmail } from '../../../actions/user'
import { showNotification } from '../../../actions/notifications'
import handleAccountRequest from '../../account/utils/handleAccountRequest'

function UpdateEmailContainer(props) {
  const {
    user, updateUserEmail, showNotification, hideModal,
  } = props
  const [submitLoading, setSubmitLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [attemptNumber, setAttemptNumber] = useState(1)

  function onSubmit(formData) {
    const requestData = {
      email: formData.email,
      password: formData.currentPassword,
      recaptchaResponse: formData.recaptchaResponse,
    }
    handleAccountRequest({
      setSubmitLoading,
      setErrorMessage,
      makeRequest: () => updateUserEmail(requestData, user.id),
      hideModal,
      showSuccessNotification: () => showNotification(`to ${formData.email}`, 'Updated Email', 'default'),
      requestName: 'updateEmail',
      errorCallback: () => setAttemptNumber(attemptNumber + 1),
    })
  }

  return (
    <React.Fragment>

      <EditUserEmailForm
        email={user.email}
        onSubmit={(formData) => onSubmit(formData)}
        submitLoading={submitLoading}
        attemptNumber={attemptNumber}
      />

      {errorMessage && (
        <div className='accountForm-error'>
          {errorMessage}
        </div>
      )}

    </React.Fragment>
  )
}

export default connect(
  (state) => ({
    user: state.user,

  }),
  { updateUserEmail, showNotification },
)(UpdateEmailContainer)
